// Sample data for BetVerse when database is empty

export const sampleTipsters = [
  {
    id: '1',
    name: 'Marcus "The Shark" Silva',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Marcus',
    country: 'BR',
    roi: 34.5,
    winRate: 82,
    streak: 14,
    totalTips: 2847,
    isPremium: true,
    isVerified: true,
  },
  {
    id: '2',
    name: 'Elena Rodriguez',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Elena',
    country: 'ES',
    roi: 28.7,
    winRate: 76,
    streak: 9,
    totalTips: 1923,
    isPremium: true,
    isVerified: true,
  },
  {
    id: '3',
    name: 'James "The Oracle" Chen',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=James',
    country: 'UK',
    roi: 31.2,
    winRate: 79,
    streak: 7,
    totalTips: 3104,
    isPremium: true,
    isVerified: true,
  },
  {
    id: '4',
    name: 'Sarah Mitchell',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah',
    country: 'US',
    roi: 22.8,
    winRate: 71,
    streak: -2,
    totalTips: 1456,
    isPremium: false,
    isVerified: true,
  },
  {
    id: '5',
    name: 'Luca Bianchi',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Luca',
    country: 'IT',
    roi: 26.3,
    winRate: 74,
    streak: 5,
    totalTips: 1782,
    isPremium: true,
    isVerified: true,
  },
  {
    id: '6',
    name: 'Amara Okafor',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Amara',
    country: 'CA',
    roi: 19.5,
    winRate: 68,
    streak: 3,
    totalTips: 987,
    isPremium: false,
    isVerified: false,
  },
];

export const sampleAIPersonas = [
  {
    id: 'ai1',
    name: 'The Underdog Oracle',
    avatar_url: 'https://api.dicebear.com/7.x/bottts/svg?seed=Oracle',
    bio: 'AI specialist in identifying value in underdogs. Analyzes sentiment shifts and line movement to find +EV opportunities.',
    personality_traits: ['analytical', 'contrarian', 'value-focused'],
    writing_style: 'Data-driven with a focus on expected value and market inefficiencies',
    preferred_sports: ['Football', 'Basketball', 'Tennis'],
    regions: ['Europe', 'North America'],
    performance_profile: {
      win_rate: 73.2,
      roi: 24.8,
      total_tips: 1847,
      best_streak: 11,
    },
  },
  {
    id: 'ai2',
    name: 'Market Whisperer AI',
    avatar_url: 'https://api.dicebear.com/7.x/bottts/svg?seed=Whisperer',
    bio: 'Real-time odds monitoring AI that detects arbitrage opportunities and value bets across 50+ bookmakers.',
    personality_traits: ['precise', 'quantitative', 'rapid'],
    writing_style: 'Technical and numbers-focused with clear edge analysis',
    preferred_sports: ['Football', 'Basketball', 'Baseball'],
    regions: ['Global'],
    performance_profile: {
      win_rate: 69.8,
      roi: 21.3,
      total_tips: 3204,
      best_streak: 8,
    },
  },
  {
    id: 'ai3',
    name: 'Momentum Hunter',
    avatar_url: 'https://api.dicebear.com/7.x/bottts/svg?seed=Momentum',
    bio: 'AI trained on team psychology and momentum indicators. Specializes in live betting and in-play adjustments.',
    personality_traits: ['adaptive', 'psychological', 'timing-focused'],
    writing_style: 'Narrative-driven with emphasis on team dynamics and momentum shifts',
    preferred_sports: ['Basketball', 'Hockey', 'Tennis'],
    regions: ['North America', 'Asia'],
    performance_profile: {
      win_rate: 71.5,
      roi: 19.7,
      total_tips: 2156,
      best_streak: 9,
    },
  },
];

export const sampleTips = [
  {
    id: 'tip1',
    title: 'Arsenal vs Chelsea - Home Win',
    sport: 'Football',
    league: 'Premier League',
    match: 'Arsenal vs Chelsea',
    tipType: 'Arsenal to Win',
    odds: 2.45,
    confidence: 87,
    price: 15,
    currency: 'USD',
    isPremium: false,
    timeLeft: '2h 15m',
    created_at: new Date(Date.now() - 1000 * 60 * 30).toISOString(),
    status: 'pending',
    tipster: {
      win_rate: 82,
      roi_percentage: 34.5,
      is_premium: true,
      profile: {
        display_name: 'Marcus "The Shark" Silva',
        avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Marcus',
      }
    }
  },
  {
    id: 'tip2',
    title: 'Lakers vs Warriors - Over Points',
    sport: 'Basketball',
    league: 'NBA',
    match: 'Lakers vs Warriors',
    tipType: 'Over 225.5 Points',
    odds: 1.91,
    confidence: 72,
    price: 0,
    currency: 'USD',
    isPremium: false,
    timeLeft: '5h 42m',
    created_at: new Date(Date.now() - 1000 * 60 * 60).toISOString(),
    status: 'pending',
    tipster: {
      win_rate: 76,
      roi_percentage: 28.7,
      is_premium: true,
      profile: {
        display_name: 'Elena Rodriguez',
        avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Elena',
      }
    }
  },
  {
    id: 'tip3',
    title: 'Djokovic vs Alcaraz - Player 1 Win',
    sport: 'Tennis',
    league: 'ATP Masters',
    match: 'Djokovic vs Alcaraz',
    tipType: 'Djokovic to Win',
    odds: 1.75,
    confidence: 91,
    price: 25,
    currency: 'USD',
    isPremium: true,
    timeLeft: '18h 20m',
    created_at: new Date(Date.now() - 1000 * 60 * 15).toISOString(),
    status: 'pending',
    tipster: {
      win_rate: 79,
      roi_percentage: 31.2,
      is_premium: true,
      profile: {
        display_name: 'James "The Oracle" Chen',
        avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=James',
      }
    }
  },
  {
    id: 'tip4',
    title: 'Real Madrid vs Barcelona - BTTS',
    sport: 'Football',
    league: 'La Liga',
    match: 'Real Madrid vs Barcelona',
    tipType: 'Both Teams to Score',
    odds: 1.65,
    confidence: 79,
    price: 20,
    currency: 'USD',
    isPremium: true,
    timeLeft: '1d 4h',
    is_ai_generated: true,
    created_at: new Date(Date.now() - 1000 * 60 * 90).toISOString(),
    status: 'pending',
    ai_persona: {
      name: 'The Underdog Oracle',
      avatar_url: 'https://api.dicebear.com/7.x/bottts/svg?seed=Oracle',
    }
  },
];

export const sampleWinningTips = [
  {
    tip_id: 'win1',
    title: 'Manchester City 3-1 - Home Win',
    sport: 'Football',
    odds: 3.20,
    confidence_level: 84,
    persona_name: 'Market Whisperer AI',
    persona_avatar: 'https://api.dicebear.com/7.x/bottts/svg?seed=Whisperer',
    win_rate: 69.8,
    roi: 21.3,
  },
  {
    tip_id: 'win2',
    title: 'Celtics ML + Over 218.5',
    sport: 'Basketball',
    odds: 2.85,
    confidence_level: 79,
    persona_name: 'Momentum Hunter',
    persona_avatar: 'https://api.dicebear.com/7.x/bottts/svg?seed=Momentum',
    win_rate: 71.5,
    roi: 19.7,
  },
  {
    tip_id: 'win3',
    title: 'Nadal vs Medvedev - Set 3 Over 9.5',
    sport: 'Tennis',
    odds: 2.40,
    confidence_level: 88,
    persona_name: 'The Underdog Oracle',
    persona_avatar: 'https://api.dicebear.com/7.x/bottts/svg?seed=Oracle',
    win_rate: 73.2,
    roi: 24.8,
  },
  {
    tip_id: 'win4',
    title: 'Bayern Munich -1.5 Asian Handicap',
    sport: 'Football',
    odds: 2.10,
    confidence_level: 76,
    persona_name: 'Marcus "The Shark" Silva',
    persona_avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Marcus',
    win_rate: 82,
    roi: 34.5,
  },
  {
    tip_id: 'win5',
    title: 'Rangers vs Bruins - Over 6.5 Goals',
    sport: 'Hockey',
    odds: 2.65,
    confidence_level: 72,
    persona_name: 'Elena Rodriguez',
    persona_avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Elena',
    win_rate: 76,
    roi: 28.7,
  },
];

export const sampleStats = {
  total_tipsters: 15247,
  total_tips_today: 342,
  active_users: 84731,
  avg_roi: 23.4,
  top_sports: [
    { sport: 'Football', count: 156 },
    { sport: 'Basketball', count: 98 },
    { sport: 'Tennis', count: 58 },
    { sport: 'Baseball', count: 30 },
  ],
};

export const sampleRecentWins = [
  {
    id: 'rw1',
    userName: 'Mike_Betting',
    tipTitle: 'Chelsea Win',
    odds: 2.85,
    profit: 185,
    timestamp: new Date(Date.now() - 1000 * 60 * 5).toISOString(),
  },
  {
    id: 'rw2',
    userName: 'SportsFan21',
    tipTitle: 'Lakers ML',
    odds: 1.95,
    profit: 95,
    timestamp: new Date(Date.now() - 1000 * 60 * 12).toISOString(),
  },
  {
    id: 'rw3',
    userName: 'BetMaster_Pro',
    tipTitle: 'Over 2.5 Goals',
    odds: 1.75,
    profit: 75,
    timestamp: new Date(Date.now() - 1000 * 60 * 18).toISOString(),
  },
  {
    id: 'rw4',
    userName: 'TennisPro88',
    tipTitle: 'Djokovic ML',
    odds: 2.20,
    profit: 120,
    timestamp: new Date(Date.now() - 1000 * 60 * 25).toISOString(),
  },
  {
    id: 'rw5',
    userName: 'GoldenTouch',
    tipTitle: 'Bayern -1.5',
    odds: 3.10,
    profit: 210,
    timestamp: new Date(Date.now() - 1000 * 60 * 33).toISOString(),
  },
];
